
const OEIconCodes = {

    mainMenu: '\uF0C9',

    home: '\u2009',
    settings: '\uF013',
    tree: '\uF22a',
    substructure: '\uF23B',
    selection: '\u2006',
    search: '\u2005',
    cut: '\u200A',
    label: '\uF02C',
    note: '\u2007',
    arrow: '\uF22F',
    userObject: '\u00C9',
    info: '\uF129',
    infoQuestionMark: '\u00FF',
    help: '\u00FF',
    stateBack: '\uF053',
    stateForth: '\uF054',
    animation: '\uF01D',
    presentation: '\u221E',
    mediaCenter: '\uF144',
    screenshot: '\u00C5',
    color: '\uF2B2',
    explode: '\uF29B',
    startSelection: '\uF009',
    secondarySettings: '\uF024',
    offlineManager: '\uF019',

    key: '\uF21A',

    werkman: '\uF29E',

    close: '\uF00D',
    compress: '\uF066',
    expand: '\uF065',

    pin: '\uF08D',

    textFieldClear: '\uF057',

    textViewClose: '\uF057',

    infoMessageViewClose: '\uF05C',

    contextMenuFade: '\uF297',
    contextMenuHide: '\uF298',
    contextMenuFadeOther: '\uF296',
	contextMenuHideOther: '\uF299',
	contextMenuInfo: '\uF05a',

    cutToolTouch: '\uF2A6',
    cutToolSwipe: '\uF2A5',
    cutToolAll: '\uF29A',
    cutToolTouched: '\uF299',

    cloudDownload: '\uF0ED',
    cloudUpload: '\uF0EE',

    copyToClipboard : '\uF24D', //'\uF0EA',

    colorPicker: {
        palette: '\uF23D',
        paletteToggle: '\uF04B'
    },

    pres: {
        add: '\uF055',
        remove: '\uF014',
        save: '\uF0C7',
        load: '\uF07C',
        set: '\uF021',
        pres: '\u221E',
        slide: '\u00C6',
        slideAttribute: '\uF0C6',
        slideAnimationAttribute: '\uF008',
        audio: '\uF001',
        resetCompColors: '\uF090',
        preset: '\u2004',
        language: '\uF024',
        applyPresets: '\uF045',
        saveNoteModifier: {code: '\u2007', subCode: '\uF0C7'},
        applyNoteModifier: {code: '\u2007', subCode: '\uF045'}
    },

    presSlideAttribute: {
        add: '\uF07C',
        dump: '\uF014',
        types: {
            dummy: '\uF1B0',
            custom: '\uF135',
            link: '\uF0C1',
            array: ['\uF1B0', '\uF135', '\uF0C1']
        },
        linkTypes: {
            animation: '\uF008',
            array: ['\uF008']
        },
        syncSlideView: '\uF07E'
    },

    audioTrack: {
        open: '\uF07C',
        dump: '\uF014',
        ok: '\uF090',
    },

    assetSelection: {
        ok: '\uF14A',
        typeIcons: {
            dummy: '\uF1B0',
            animation: '\uF2A9',
            presentation: '\u221E',
            image: '\uF03E',
            video: '\uF2B9',
            web: '\uF2BA',
            pdf: '\u00CC'
        }
    },

    smartAttribute: {
        addAttribute: '\uF055',
        dumpAttribute: '\uF014',
        eventFuncEdit: '\uF111',
    },

    func: {
        addFragment: '\uF055',
        dumpFragment: '\uF014',
        media: '\uF144'
    },

    preset: {
        add: '\uF055',
        save: '\uF0C7',
        load: '\uF07C',
        dump: '\uF014',
        apply: '\uF090',
        type: {
            unknown: '\u00FF',
            dummy: '\uF10C',
            note: '\u2007',
            camera: '\uF047', //'\uF030',
            cut: '\u200A',
            color: '\uF2B2',
            components: '\uF22a'
        }
    },

    refresh: '\uF021',

    reset: '\uF0E2',
    help: '\u00FF',

    stop: '\uF04D',
    play: '\uF04B',
    pause: '\uF04C',

    chevronLeft: '\uF053',
    chevronRight: '\uF054',

    caretLeft: '\uF0D9',
    caretRight: '\uF0DA',

    forward: '\uF04E',
    backward: '\uF04A',

    eye: '\uF06E',

    addArrowNote: '\uF055',
    arrowStyleTransferToAll: '\uF122',
    arrowDump: '\uF014',
    arrowLength: '\uF07E',
    arrowWidth: '\uF07D',
    arrowExt: '\uF12A',
    arrowCopyStyle: '\uF062',
    arrowPasteStyle: '\uF063',
    arrowCopyTransformation: '\uF062',
    arrowPasteTransformation: '\uF063',

    noteShowDocument: '\uF247',
    noteShowVisibilityCheckSize: '\uF140',
    noteOrderViews: '\uF24D',
    noteStyleTransferToAll: '\uF122',
    noteStyleTransfer: '\uF122',
    noteStyleTransferToUserRef: '\uF122',
    noteStyleTransferDeselectAllStyleTransferBits: '\uF146',
    noteStyleTransferSelectAllStyleTransferBits: '\uF0FE',
    notePropertyTransferToAll: '\uF122',
    notePropertyTransfer: '\uF122',
    notePropertyTransferToUserRef: '\uF122',
    notePropertyTransferDeselectAllTransferBits: '\uF146',
    notePropertyTransferSelectAllTransferBits: '\uF0FE',
    noteDump: '\uF014',
    noteShowAlways: '\uF06E',
    noteNotShowAlways: '\uF070',
    noteDecFont: '\uF031',
    noteIncFont: '\uF031',
    noteTextColor: '\uF031',
    noteBorderColor1: '\uF040',
    noteBorderColor2: '\uF096',
    noteLineColor: '\uF040',
    noteBackgroundColor: '\uF043',
    noteBorder : '\uF24D',
    noteNoBorder: '\uF096',
    noteCornerRadius: '\uF096',
    notePadding: '\u2002',
    noteLinkPointSize1: '\uF07E',
    noteLinkPointSize2: '\uF111',
    noteExt: '\uF12A',
    noteShowColor: '\uF068',
    noteIsInDocument: '\uF247',
    noteIsNotInDocument: '\uF248',
    notePreset: '\uF045',
    noteFunction: '\u1FF8',
    noteRTFFileLoad: '\uF07C',
    noteImageLoad: '\uF07C',
    noteImageDump: '\uF014',
    noteAddState: '\uF005',
    noteAddStateNew: '\uF055',
    noteAddStateSet: '\uF021',
    noteAddStateApply: '\uF122',
    noteAddStateDump: '\uF014',
    noteAttribute: '\uF28A',

    noteHAlignmentLeft: '\uF226',
    noteHAlignmentCenter: '\uF225',
    noteHAlignmentRight: '\uF224',
    noteVAlignmentTop: '\uF221',
    noteVAlignmentCenter: '\uF222',
    noteVAlignmentBottom: '\uF223',

    userObjectDump: '\uF014',
    userObjectAlignToCamera: '\uF06E',
    userObjectAlignToCameraVPMainAxis: '\uF1AB',
    userObjectHighlighting: '\u1FF1',
    userObjectPassthrough: '\uF0A7',
    userObjectCameraPivot: '\uF021',
    userObjectTextureLoad: '\uF07C',
    userObjectTextureDump: '\uF014',
    userObjectMaterial: '\uF1FC',
    userObjectCopyGeometry: '\uF062',
    userObjectPasteGeometry: '\uF063',
    userObjectCopyTransformation: '\uF062',
    userObjectPasteTransformation: '\uF063',

    ctSwitchOff: '\uF1B2',
    ctSwitchOn: '\uF1B3',

    ctActivationOn: '\uF00C',
    ctActivationOff: '\uF00C',

    ctCategoriesSwitch: '\uF23B',
    ctCategoriesActivation: '\uF23B',

    ctNodeTerminal: '\uF016',
    ctNodeExpanded: '\uF07C',
    ctNode: '\uF07B',
    ctNodeTerminalDot: '\uF111',

    licensingSettings: '\uF013',
    licensingPlay: '\uF144',
    licensingBuy: '\uF07A',
    licensingEnvelope: '\uF0E0',
    licensingKeyInput: '\uF0A9',
    licensingInfoRefresh: '\uF0E2',
    licensingInfoDeactivate: '\uF057',
    licensingInfoRemove: '\uF014',
    licensingInfoAdd: '\uF067',

    download: '\uF019',

    mcItemWithoutSound: '\uF1F7',
    mcItemWithSound: '\uF0A2',
    mcPresentationSlides: '\u221E',
    mcPresentationDuration: '\uF017',
    mcPlayModeBackward: '\uF053',
    mcPlayModeForward: '\uF054',

    overlayTextBox:    {
        textBoxClose: '\uF057',
        textBoxToLeft: '\uF137',
        textBoxToRight: '\uF138'
     },

    offlineManagerView:    {
        updateCache: '\uF0E2'
    },

    helpView: {
        advice: '\uF2b7',
        manual: '\uF2b7',
        manualInteractive: '\u221E',
        quickStart: '\u00C6',
        videoTutorials: '\u00C4',
        tutorReset: '\u00C7',
        disableTutor: '\u00C7',
        usageRights: '§',
        licenseAgreement: '\uF15C',
        dot: '\uF111',
        helpHandling: {
            navigation: {
                rotateTouch: '\u1FF6',
                rotateMouse: '\u1FFB',
                moveTouch: '\u1FF5',
                moveMouse: '\u1FFD',
                zoomTouch: '\u1FF4',
                zoomMouse: '\u1FFC',
                resetTouch: '\u1FF2',
                resetMouse: '\u00C3',
                centerTouch: '\u1FF7'
            },
            view: {
                contextTouch: '\u1FF8',
                contextMouse: '\u1FFE'
            },
            cut: {
                touchTouch: '\u1FF8',
                touchMouse: '\u1FFD',
                swipeTouch: '\u1FF6',
                swipeMouse: '\u1FFB',
                doubleClickTouch: '\u1FF7',
                doubleClickMouse: '\u1FFF',
                shiftTouch: '',
                shiftMouse: '\u1FFC'
            }
        }
    },

    freePremiumView: {
        email: '\u00DA',
        website: '\uF26B',
    },

    tutorForward: '\uF138',
    tutorBackward: '\uF137',
    tutorClose: '\uF057',

    amboss: {
        anatomyTarget: '\uF237',
        headTarget: '\uF234',
        organsTarget: '\uF235',
        biologyTarget: '\uF236'
    },

    anatomy: {
        anatomyTarget: '\uF237',
        biologyTarget: '\u00DE',
        headTarget: '\uF234',
        organsTarget: '\uF235'
    },

    bayer: {
        anatomyTarget: '\uF238',
        bayerTarget: '\u00CB',
        octTarget: '\u00CA',
        optiTarget: '\uF23A',
        surgeryTarget: '\u00CD'
    },

    bbraun: {
        opTarget: '\u00CD',
        anatomyTarget: '\u00CE'
    },

    cell: {
        cellsTarget: '\uF236',
        cambridgeWelcomeView: '\uF12A'
    },

    demo: {
        anatomyTarget: '\u00CE',
        cellTarget: '\u00DE',
        histologyTarget: '\u00E0',
        ophthalmologyTarget: '\uF238',
        orthopedicTarget: '\u00CD',
        toxicologyTarget: '\u00DB',
        visceralTarget: '\uF23C'
    },

    ear: {
        anatomyTarget: '\u00CE'
    },

    equineHoof: {
        anatomyTarget: '\uF237',
        dynamicTarget: '\uF29D'
    },

    eyeOCT: {
        anatomyTarget: '\uF238',
        optiTarget: '\uF23A',
        octTarget: '\u00CA'
    },

    implantcast: {
        opTarget: '\u00CD',
        anatomyTarget: '\u00CE',
        demoAnimLoop: '\uF021',
        accountEntry: '\uF007',
        registerClose: '\uF057'
    },

    ortho: {
        anatomyTarget: '\uF237',
        headTarget: '\uF234'
    },

    mediCADemy: {
        implantcastTarget: '\u00CE',
        idoTarget: '\uF238',
        ohstTarget: '\u00CD',
    },

    school: {
        biologyTarget: '\uF18C',
        chemistryTarget: '\uF0C3',
        geographyTarget: '\uF0AC',
        physicsTarget: '\uF23A',
        mathTarget: '\uF12B'
    },

    science: {
        anatomyTarget: '\u00CE'
    },

    skin: {
        anatomyTarget: '\u00CA'
    },

    sport: {
        anatomyTarget: '\u00CE'
    },

    surgery: {
        anatomyTarget: '\u00CE',
        approachOpTarget: '\u00CD',
        ophthalmologyTarget: '\uF238',
        orthoOpTarget: '\u00CD'
    },

    thieme: {
        anatomyTarget: '\uF237',
        biologyTarget: '\u00DE',
        headTarget: '\uF234'
    },

    toxnetz: {
        organsTarget: '\uF235',
        nervousSystemTarget: '\uF238',
        skeletonTarget: '\uF237',
        formulaeTarget: '\uF18C'
    },

    xRay: {
        xRayArmTarget: '\uF1EB',
        xRayLegTarget: '\uF1EB',
        xRayTrunkTarget: '\uF1EB',
        anatomyTarget: '\u00CE',
        resetCamera: '\uF07E',
        textBox: '\uF0F6',
        patientControlBtn: '\uF06E',
        website: '\uF0AC',
    },

    xRayIcarus: {
        anatomyTarget: '\uF238',
        xRayTarget: '\uF23A',
        resetCamera: '\uF07E',
        textBox: '\uF0F6'
    },

    zeissOpti: {
        targetSwiffel: '\uF021',
        targetArrow: '\uF116',
        pencil: '\uF21C',
        correction: '\uF21B',
        anatomyTarget: '\uF238',
        UVTarget: '\uF239',
        optiTarget: '\uF23A'
    }
};

export default OEIconCodes;